export default __webpack_public_path__ + "static/media/feature_2.61eb77b1.jpg";